import React, { useEffect } from "react";
import { Form, Input, Select } from 'antd';
import FormItem from "components/fields/FormItem";
import { connect, useDispatch, useSelector } from "react-redux";
import { 
	getHolidayDetails, doHolidayCreate, doHolidayUpdate 
} from "../../../../redux/holiday/holidayState";
import CrudButtons from "components/button/crudbuttons";
import { requiredField } from "utils/crudSagaHelper";
import { getLabel } from "utils";
import SwitchField from "components/fields/SwitchField";
import SelectDate from "components/fields/SelectDate";

const HolidayForm = ({
	onCancel,
	submitLabel,
	...props
}) => {
	const dispatch = useDispatch();
  	const [form] = Form.useForm();
	const { recordId, mode } = props;  	

	const recordData = useSelector((state) => state.holiday.holidayDetails?.data);
	const doCreate = (data) => dispatch(doHolidayCreate(data));
	const doUpdate = (data) => dispatch(doHolidayUpdate(data));

	useEffect(() => {
		if(recordId){
			dispatch(getHolidayDetails(recordId));
		}
	}, [dispatch, recordId]);

	useEffect(() => {
		if(recordData){
			form.resetFields();
			const { holiday:hol_name, hol_type_id, ...rest } = recordData;

			const initialValues = {
				...rest,
				hol_id: recordData?.hol_id ?? "",
				hol_name: recordData?.hol_name ?? "",
			    hol_type_id: recordData?.hol_type_id ?? "",
				hol_month: recordData?.hol_month ?? undefined,
				hol_day: recordData?.hol_day ?? undefined,
				hol_is_recurring: recordData?.hol_is_recurring ?? null,
			};	
	        form.setFieldsValue(initialValues);

        }
    }, [recordData, form]);


  	const onSubmit = (formData) => {	
		console.log(formData);
    	try {  
			formData.hol_is_recurring = Number(Boolean(formData.hol_is_recurring));

			recordData.hol_id > 0 ? doUpdate(formData): doCreate(formData); 
    	} catch (error) {
      		console.error('Save failed:', error);
    	}
  	};
  
  	return (
    	<Form className={mode !== "view" ? "form" : ""}
			form={form} 
			layout="vertical"
			onFinish={onSubmit}
		>   
			<FormItem
				name="hol_id"
				hidden
			>
				<Input type="hidden"/>
			</FormItem>
			<div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">        		            	            
				<FormItem className="font-medium mb-2"
					name="hol_name"
					label="Holiday Name"
					rules={[requiredField]}
					
				>
					{mode !== 'view' ?
						<Input id="hol_name"
							className="input-field"
							maxLength={100}
							placeholder="Enter holiday name"
						/>
						: 
						<label className="text-base label-value dark:text-white">
							{recordData?.hol_name}
						</label>
					}
				</FormItem>	  
				<FormItem className="font-medium mb-2 "
					name="hol_type_id"
					label="Type"
					rules={[requiredField()]}
				>
					{mode !== 'view' ?
						<Select id="hol_type_id"
							className="input-field"
							showSearch
							allowClear={true}
							options={recordData?.holidayTypeList}
						/>
						: 
						<label className="text-base label-value dark:text-white">
							{getLabel(recordData?.holidayTypeList, recordData?.hol_type_id)}
						</label>
					}	                
				</FormItem> 
				<FormItem
					label="Country"
					name="hol_country_id"
					rules={[requiredField()]}
					className="order-3 md:order-none"
				>
					{mode !== "view" ? 
						<Select id="hol_country_id"
							className="input-field"
							showSearch
							allowClear={true}
							options={recordData?.countryList}
						/>
						: 
						<label className="text-base label-value dark:text-white">
							{getLabel(recordData?.countryList, recordData?.hol_country_id)}
						</label>
					}
				</FormItem>

				<div className="order-4 md:contents grid grid-cols-3 gap-2 items-start">
					<div className="col-span-2 ">
						<SelectDate
							form={form}
							mode={mode}
							recordData={recordData}
							monthName="hol_month"
							dayName="hol_day"
							label="Date"
						/>
					</div>

					<div className="col-span-1">
						<FormItem
							label="Is Recurring"
							name="hol_is_recurring"
						>
							{mode !== "view" ? (
								<SwitchField
									id="hol_is_recurring"
									mode="edit"
									type="text"
									labelYes="Yes"
									labelNo="No"
								/>
							) : (
								<label className="text-base label-value dark:text-white">
									{recordData?.hol_is_recurring}
								</label>
							)}
						</FormItem>
					</div>
				</div>
			</div>


			<div className="w-full flex justify-end">
				{(mode === "edit") && (
					<CrudButtons
						mode={mode}
						recordId={recordData?.hol_id ?? 0}
						isModal={true}
						modalId={recordData?.hol_id > 0 ? 'edit_holiday' : 'add_holiday'}
						cancelLabel="Cancel"
						doHideModal={onCancel}
						submitLabel={submitLabel}
					/>
				)}
			</div> 				 			
		</Form>	 	
  	);
};

export default HolidayForm;
